<template>
    <div>
        <my-table :data="tableData" :height="tableHeight" >
            <el-table-column label="专家名称" prop="zjname">
            </el-table-column>
            
            <el-table-column label="承诺书" prop="pstime">
                <template slot-scope="scope">
                    <my-upload  
                        :file-guid="scope.row.fileguid || ''"
                        single>
                    </my-upload>
                </template>
            </el-table-column>
        </my-table>
        
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
import STATE_CONF from './config/stateBtn'
import BTN_CONF from './config/btn-list'
import pbTemlplate from './components/pbTemlpate'
import PushType from '@/components-sys/push-type'

export default {
    mixins: [ LIST_PAGE_MIXIN ],
    components: { pbTemlplate,PushType },
    data() { 
        return {
            pgData: {
                bdcode:"",
                ext5:"",
                sortname : 'a.bdcode',
				sortorder : "asc",
            },

            zgys:"",
            initModel:{},

            pbTemlplateData:{
                bdcode:"",
            },
            templateDialogVisible:false,

            STATE_CONF,
            BTN_CONF,
        }
    },
    computed: {
        
    },                                                                                                                              
    methods: {
        getTableData(){
            var that=this;
            that.$get(`${this.getGetters('bidUrl')}/revision/kaibiao/pbbg/getZjList.json`,{
                bdcode:that.pgData.bdcode,
            }, (data, res) => {
                that.tableData = data;
            });
        }
    },
    created() {
        this.pgData.bdcode = this.getQuery('bdcode');
    },
    mounted() {
        this.getTableData();
    }
}
</script>

<style scoped lang="scss">
</style>